
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IMetadataAction } from "@tylertech/tyler-api-types";

/**
 * ContractService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ContractService<T = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    ContractModuleLicensed(): Promise<boolean> {
        return this.$apiService.sendAuth("IContractService/ContractModuleLicensed");
    }
    DeleteContract(id: string): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IContractService/DeleteContract", id);
    }
    GetContracts(filterString?: string): Promise<T[]> {
        return this.$apiService.sendAuth("IContractService/GetContracts", null, filterString);
    }
}
